<template>
  <!-- 占位文本配置组件
       @author: 王汝鹏
       @date: 2019-9-10
   -->
  <div class="setting-item">
    <el-form-item label="提示语"> 
      <el-input v-model="placeholder" 
                placeholder="请输入默认提示"
                :maxlength="20" 
                :limit-length="20"></el-input>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 基础属性-提示语
     *  @description 将 placeholder 字段映射到当前 placeholder 计算属性
     *  @return {String}
     *  @author 王汝鹏
     *  @version 2019-09-10
     */
    ...mapComputed({
      placeholder: { 
        parent: i => i.baseOption,
        attr: "placeholder",
      }
    }),
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingPlaceholder.vue